import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  showSuccess(message: string, type: 'success' | 'error' | 'info' = 'info', duration: number = 3000) {
    const panelClass = `snackbar-success`;
    this.snackBar.open(message, '', {
      duration,
      panelClass: [panelClass],
      verticalPosition: 'top',  
      horizontalPosition: 'center' 
    });
  }

  showError(message: string, type: 'success' | 'error' | 'info' = 'info', duration: number = 3000) {
    const panelClass = `snackbar-error`;
    this.snackBar.open(message, '', {
      duration,
      panelClass: [panelClass],
      verticalPosition: 'top',  
      horizontalPosition: 'center' 
    });
  }

  showInfo(message: string, type: 'success' | 'error' | 'info' = 'info', duration: number = 3000) {
    const panelClass = `snackbar-info`;
    this.snackBar.open(message, '', {
      duration,
      panelClass: [panelClass],
      verticalPosition: 'top',  
      horizontalPosition: 'center' 
    });
  }
}
